import { render, staticRenderFns } from "./UploadPublicImage.vue?vue&type=template&id=748e2f82&scoped=true"
import script from "./UploadPublicImage.vue?vue&type=script&lang=js"
export * from "./UploadPublicImage.vue?vue&type=script&lang=js"
import style0 from "./UploadPublicImage.vue?vue&type=style&index=0&id=748e2f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e2f82",
  null
  
)

export default component.exports